import { render } from "./policy.poddisruptionbudget.vue?vue&type=template&id=4b30e08f"
import script from "./policy.poddisruptionbudget.vue?vue&type=script&lang=js"
export * from "./policy.poddisruptionbudget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__